//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { PaymentSourceInputItem } from './PaymentSourceInputItem';
import { PaymentProcessorType } from './Enums';

export class PayPalCommercePlatformPaymentSourceInputItem extends PaymentSourceInputItem {
    VaultSetupToken: string | null = null;
    OrderID: string | null = null;
    SerializedTransactionDetails: string | null = null;
    IntentAutoPayCode: string | null = null;
    override readonly ProcessorType: PaymentProcessorType = PaymentProcessorType.PayPalCommercePlatform;

    constructor(initializer?: Partial<Omit<PayPalCommercePlatformPaymentSourceInputItem, "ProcessorType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PayPalCommercePlatformPaymentSourceInputItem";
}
